<template>
<div>
  <div class="navbar-fixed">
  <nav class="white">
  <div class="nav-wrapper"> 
    <ul>
      <li>
        <a class="waves-effect  plus-64" @click="$_toggleNav()"><i class="material-icons grey-text text-darken-3">menu</i></a>
      </li>
      <li v-if="user && user.id">
        <span class="chip">
          <img  v-if="user.acf.profile_image" :src="user.acf.profile_image.url" alt="">
          {{user.name}}
        </span>
      </li>
   <!--  <li class="grey-text text-darken-2 logo-li">
        <span class="left">ECSC Docs</span> <i class="material-icons route-sep">chevron_right</i><span class="route-name" v-html="$route.name"></span>
         <i v-if="$route.params.slug" class="material-icons route-sep">chevron_right</i> <span class="small-slug" v-html="$route.params.slug"></span>
      </li> -->
    </ul>
  <!--   <ul class="hide-on-med-and-down" style="position: relative; margin-left: 300px;" v-if="user && user.id && user.id === 1">
      
      <NavDropDown v-for="nav in navigtaion.items" :key="nav.id" :data-item="nav"/>
    </ul> -->
    <ul class="right float-on-small top-right">
      <li>
      <router-link to="/login" v-if="!authStatus">
          <button tag="button"  class="btn right btn-medium waves-effect white indigo-text text-accent-3 z-depth-0 sign-in-btn">
          <i class="material-icons left">account_circle</i> Sign In
        </button>
      </router-link>
      <button v-else @click="$_logout()" class="btn right btn-medium waves-effect white indigo-text text-accent-3 z-depth-0 sign-in-btn">
        Logout
      </button>
      </li>
      <li>
        &nbsp; &nbsp; 
        <!--   <app-bar></app-bar> -->
      </li>
    </ul>
    </div>
  </nav>
  </div>
  <side-nav
  :auth-status="signedIn"
  @status="$_menuState($event)"
    :navStatus="navState"
  >
  </side-nav>
</div>
</template>

<script>
import {mapState} from 'vuex'
import contentService from '@/services/contentService.js'
import authService from '@/services/authService'
import sideNav from '@/components/sideNav.component'
import NavDropDown from '@/components/navDropDown.component'
//import appBar from '@/components/appBar.component'
export default {
name:'navBar',
props:{
  alignment:{
    type:String,
    default:'left'
  }
},
components:{
  NavDropDown,
  sideNav
},
data(){
  return {
    appStatus: navigator.onLine ? true : false,
    navState:'close',
    navigtaion: [],
    authStatus:false,
  }
},
mounted(){
  this.$_checkAuthStatus()
  this.getNavItems()
},
watch:{
  $route:function(nV){
   nV 
   ? this.appStatus = navigator.onLine ? true : false
   : false 
   nV 
   ? this.$_checkAuthStatus()
   : false
  }
},
computed:{
  ...mapState({
    user: state => state.user
  }),
  signedIn:{
    get(){
      return this.authStatus
    }
  }
},
methods:{
  $_toggleNav(){
    this.navState === 'close' 
    ? this.navState = 'open'
    : this.navState = 'close'
  },
  getNavItems () {
    contentService
    .getNavItems(158)
    .then(results => {
      this.navigtaion = results.data
    })
  },
  $_logout(){
    authService.logout()
    this.$_checkAuthStatus()
    setTimeout(() => {
      this.$store.commit('CLEAR_USER_DATA')
    }, 900);
  },
  $_checkAuthStatus(){
    this.authStatus =  authService.getCookie('wcmCookie') ? true : false
  },
  $_menuState($event){
   if( $event === 'closed') setTimeout(() => { this.navState = 'close'}, 150);
   if( $event === 'opened') this.navState !== 'open' ? this.navState = 'open' : false
  }
}
}
</script>

<style scoped lang="scss">
.navbar-fixed {
  height:56px; 
  nav {
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.02), 0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 1px 10px 0px rgba(0, 0, 0, 0.02) !important;
  }
  nav, i, a, .navbar-fixed  {
    height:56px; line-height: 56px;
  }
   @media screen  and (min-width: 768px){
    &.items-left .nav-wrapper:not( .items-default .nav-wrapper) {
      width: calc(100% - 325px);
    }
  }
}
.sign-in-btn {
  margin-top:5px;
  border: 2px solid #3d5afe;
  height:44px !important;
  border-radius: 8px;
  line-height: 40px !important;
  i {
    &.left{
        line-height: 44px;
        margin: 0px 10px 0px 0px;
    }
  }
}
.plus-64 {
  width:64px !important;
  text-align: center;
}
.logo-li {
  font-size: 19px;
  letter-spacing: 1px;
  font-weight: 400;
  display: flex;
}
span.route-name {
    text-transform: capitalize;
}
span.small-slug {
    text-transform: capitalize;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 2px;
}
</style>


